<template>
  <v-card flat rounded="lg">
    <v-card-title class="subtitle-1 font-weight-bold"
      >Dados do pedido</v-card-title
    >
    <v-card-text>
      <v-select
        label="Filial"
        no-data-text="Nenhuma filial disponível"
        placeholder="Selecione a filial"
        persistent-placeholder
        :items="filiais"
        v-model="pedido_item.filialSelecionada"
        item-text="descricao"
        return-object
        :disabled="lista_itens.length > 0"
      ></v-select>
      <v-select
        label="Cad-Pro"
        no-data-text="Nenhum cad-pro disponível"
        placeholder="Selecione o cad-pro"
        persistent-placeholder
        return-object
        :items="pedido_item.cliente.cadpros"
        v-model="pedido_item.cadproSelecionado"
        :disabled="lista_itens.length > 0"
      >
        <template v-slot:item="{ item }">
          {{ getTextCadPro(item) }}
        </template>
        <template v-slot:selection="{ item }">
          {{ getTextCadPro(item) }}
        </template>
      </v-select>
      <v-select
        label="Cultura"
        no-data-text="Nenhuma cultura disponível"
        placeholder="Selecione a cultura"
        persistent-placeholder
        :items="culturas"
        return-object
        item-text="descricao"
        v-model="pedido_item.culturaSelecionada"
        :disabled="lista_itens.length > 0"
      ></v-select>
      <v-select
        label="Safra"
        no-data-text="Nenhuma safra disponível"
        placeholder="Selecione a safra"
        persistent-placeholder
        return-object
        item-text="safra"
        :items="getterSafras()"
        v-model="pedido_item.safraSelecionada"
        :disabled="lista_itens.length > 0"
      ></v-select>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="pedido_item.vencimento"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dateModel"
            label="Data de vencimento do pedido"
            readonly
            v-bind="attrs"
            v-on="on"            
            append-icon="mdi-calendar-range-outline"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="pedido_item.vencimento"
          scrollable
          locale="pt"
          :min="minData()"
          :max="maxData()"
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.dialog.save(pedido_item.vencimento)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  watch: {
    ["pedido_item.vencimento"]: function () {
      this.recalcularProduto();
    },
  },
  computed: {
    ...mapState("insumos", [
      "culturas",
      "pedido_item",
      "filiais",
      "lista_itens",
      "config",
    ]),
    dateModel: {
      get: function () {
        return moment(this.pedido_item.vencimento).format("DD/MM/YYYY");
      },
      set: function (value) {
        this.pedido_item.vencimento = value;
      },
    },
  },
  data: () => ({
    modal: false,
    date: "",
  }),
  methods: {
    ...mapGetters("insumos", ["getterSafras"]),
    ...mapActions("insumos", ["recalcularProduto"]),
    getTextCadPro(value) {
      return `${value.nrcadpro} - ${value.desc_municipio}`;
    },
    minData() {
      return moment().toISOString();
    },
    maxData() {
      if (this.pedido_item.safraSelecionada) {
        return moment(this.pedido_item.safraSelecionada.vctofinal).format(
          "YYYY-MM-DD"
        );
      }
      return moment().toISOString();
    },
  },
  mounted() {
    if (
      this.pedido_item.vencimento == null ||
      this.pedido_item.vencimento == ""
    )
      this.pedido_item.vencimento = this.config.vcto_inicial;

    if (this.filiais.length > 0 && this.pedido_item.filialSelecionada == null) {
      this.pedido_item.filialSelecionada = this.filiais[0];      
    }

    if (this.culturas.length > 0 && this.pedido_item.culturaSelecionada == null)
      this.pedido_item.culturaSelecionada = this.culturas[0];

    if (
      this.getterSafras().length > 0 &&
      this.pedido_item.safraSelecionada == null
    )
      this.pedido_item.safraSelecionada = this.getterSafras()[0];

    if (
      this.pedido_item.vencimento == "" ||
      this.pedido_item.vencimento == null
    ) {
      this.pedido_item.vencimento = moment().format("YYYY-MM-DD");
    }
  },
};
</script>

<style>
</style>